import { type FormGroupContextField } from "@common/contexts/FormGroup";

export const recalculateColSpan = (fields: FormGroupContextField[]): FormGroupContextField[] => {
  const candidates = fields.filter((x) => !x.info?.isHidden);

  const remaining = candidates.reduce((res, x) => res - (x.info?.colSpan ?? 0), 12);
  if (remaining > 0) {
    const unsetCount = candidates.filter((x) => !x.info?.colSpan).length;
    if (unsetCount) {
      const colSpan = remaining / unsetCount;
      return fields.map<FormGroupContextField>((x) => {
        return {
          ...x,
          colSpan: x.info?.colSpan ?? colSpan
        };
      }, []);
    }
  }

  return fields;
};
